<div class="px-1 py-1 space-y-1 text-center">
  @if (active_account()) {
  <div>
    <app-widget-box name="Your Account" [dark]="true">
      <div class="space-y-2">
        <div>
          <app-widget-data key="Address" value="{{active_account()?.address | address}}">
          </app-widget-data>
        </div>
        <div>
          <app-widget-data key="Coins" value="{{coins_balance() | amount}} SUI">
          </app-widget-data>
        </div>
        <div>
          <app-widget-data key="Tokens" value="{{tokens_balance() | amount}} KYOVY">
          </app-widget-data>
        </div>
      </div>
      <div>
        <app-widget-button (clicked)="openWallet()" heading="Manage Account">
        </app-widget-button>
      </div>
    </app-widget-box>
  </div>
  }
  @else {
  <div>
    <app-widget-box name="Your Account" description="Connect your wallet to start playing" [dark]="true">
      <div>
        <app-widget-button (clicked)="openWallet()" heading="Connect Wallet">
        </app-widget-button>
      </div>
    </app-widget-box>
  </div>
  }
</div>